import React from 'react';
import { connect } from "react-redux";
import {Card, Container, Form, Input, Button, Message, Radio} from "semantic-ui-react";
import {fetchSourceDetailFromID} from "../../data-sources/actions/SourceActions";
import Select from "react-select";
import Toggle from "react-toggle";
import "react-toggle/style.css";
import lodash from "lodash/core";
import {
    setAssociatedServiceOptionValue,
    toggleConsentFieldValues,
    deleteVerifiableInput,
    addVerifiableInputs,
    updateSourceDetail,
    updateSourceDetailDropdowns,
    updateNotesFieldForSource,
    setAssociatedCountryOptionValue, updateResultType,
} from "../actions/AddEditDPSourceActions";
import * as Validation from "../../../common/utils/Validation";
import Table from "../../../common/components/Table/Table";
import DocumentEditor from "../../../common/partials/DocumentEditor";

const refreshOptions = require("../../../common/resources/refreshOptions.json");
const inputFields = require("../../../common/resources/inputfields.json");
const sourceTypes = require("../../../common/resources/sourcetypes.json");
const statusOptions = require("../../../common/resources/statusoptions.json")

const coverageTypeOptions = [
    {label: "% Population", value: "% Population"},
    {label: "% Business", value: "% Business"},
    {label: "Records", value: "Records"},
];

export class DataSourcesForm extends React.Component {

    // create a ref for automatic smooth scrolling to the end of
    // the form in case of error/warning
    messagesEndRef = React.createRef();

    state = {
        editVerifiableInputsArr: [],
        addNewVerifiableInputs: false,
    }

    // prepare the form with details
    componentDidMount() {
        // this.props.setSourceTypes();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        // eslint-disable-next-line no-unused-expressions
        (this.props.formErrorNotification || this.props.formWarningNotification)
            ? this.scrollToBottom() : null
    }

    scrollToBottom = () => {
        this.messagesEndRef.current.scrollIntoView({ behavior: 'smooth' })
    }

    handleConsentToggle = (name) => {
        this.props.toggleConsent(name);
    };

    handleDPSourceDismiss =() => {
        Validation.clearMessages();
    }

    handleSourceDetailChanges = (e, {name, value}) => {
        this.props.updateSourceDetail({name, value});
    }

    handleSourceDetailDropdowns = (name, change_obj) => {
        this.props.updateSourceDetailDropdowns({name, change_obj});
    }

    handleNotesFieldChangesForSource = (e, { name, value }) => {
        this.props.updateNotesForSource({ name, value });
    }

    handleServiceChange = service => {
        this.props.setAssociatedServiceValue({ service });
    };

    handleCountryChange = country => {
        this.props.setAssociatedCountryValue({ country });
    };

    handleAddNewVerifiableInputButtonClick(e) {
        e.preventDefault();
        this.setState({addNewVerifiableInputs: true})
    }

    handleSelectVerifiableInputs = (selectedElements) => {
        const {sourceObject} = this.props;
        // dummy-assign id to the selected verifiable inputs
        // this is so that the radio buttons can pick the right element when marking scores/records.
        // this id will later be replaced by the appropriate uuid at the API level.
        selectedElements.forEach((e, idx) => {
            e.id = e.label_id
            e.scores = false
            e.candidate_records = false
            e.source_id = sourceObject.source_detail.source_id
        })

        this.setState({
            editVerifiableInputsArr: selectedElements
        })
    };

    handleAddNewVerifiableInputs(e) {
        e.preventDefault();
        this.props.addVerifiableInputOption(this.state.editVerifiableInputsArr);
        this.setState({
            addNewVerifiableInputs: false,
            editVerifiableInputsArr: []
        })
    };

    handleResultTypeRadioButtonClick = (e, {value, change_obj}) => {
        this.props.updateResultType({value, change_obj})

    };

    handleDeleteVerifiableInput = (e, {value}) => {
        this.props.deleteVerifiableInput({value});
    }

    render() {

        const {
            sourceObject,
            all_services,
            all_countries,
            formMessage, formMessageHeader, formWarningNotification, formErrorNotification,
        } = this.props;

        return(
            <div className="form-page-container">
                <Container>
                    <Form>
                        <Card fluid>
                            <Card.Content>
                                <h4 className="page-section-header">Description:</h4>

                                <Form.Group widths="equal">
                                    <Form.Field required>
                                        <label>Source Type</label>
                                        <Select
                                            onChange={this.handleSourceDetailDropdowns}
                                            options={sourceTypes}
                                            placeholder="Select Source Type"
                                            isClearable={true}
                                            getOptionLabel={option => option.label}
                                            getOptionValue={option => option.id}
                                            name="source_type"
                                            value={lodash.find(sourceTypes, {
                                                value: sourceObject.source_detail.source_type
                                            })}
                                        />
                                    </Form.Field>
                                    <Form.Field
                                        control={Input}
                                        type="text"
                                        label="Source Type Identifier"
                                        placeholder="# associated with DST"
                                        value={sourceObject.source_detail.source_type_identifier}
                                        name="source_type_identifier"
                                        onChange={this.handleSourceDetailChanges}
                                    />
                                </Form.Group>

                                <Form.Group widths="equal">
                                    <Form.Field>
                                        <label>Coverage Type</label>
                                        <Select
                                            onChange={this.handleSourceDetailDropdowns}
                                            options={coverageTypeOptions}
                                            placeholder="Coverage Type Options"
                                            isClearable={true}
                                            isSearchable={true}
                                            name="coverage_type"
                                            value={lodash.find(coverageTypeOptions, {
                                                value: sourceObject.source_detail.coverage_type
                                            })}
                                        />
                                    </Form.Field>
                                    <Form.Field
                                        control={Input}
                                        type="text"
                                        label="Overall Coverage"
                                        placeholder="e.g. 90"
                                        value={sourceObject.source_detail.overall_coverage}
                                        name="overall_coverage"
                                        onChange={this.handleSourceDetailChanges}
                                    />
                                </Form.Group>

                                <Form.Group widths="equal">
                                    <Form.Field required>
                                            <label>Service Name</label>
                                            <Select
                                                styles={{
                                                    menu: provided => ({ ...provided, zIndex: 9999 })
                                                }}
                                                onChange={this.handleServiceChange}
                                                options={all_services}
                                                placeholder="Select DP Service"
                                                isClearable={true}
                                                isSearchable={true}
                                                getOptionLabel={option => option.service_name}
                                                getOptionValue={option => option.service_id}
                                                value = {lodash.find(all_services, {
                                                    service_name: sourceObject.service.service_name
                                                })}
                                            />
                                        </Form.Field>
                                    <Form.Field required>
                                        <label>Country</label>
                                        <Select
                                            styles={{
                                                menu: provided => ({ ...provided, zIndex: 9999 })
                                            }}
                                            onChange={this.handleCountryChange}
                                            options={all_countries}
                                            placeholder="Select A Country"
                                            isClearable={true}
                                            isSearchable={true}
                                            getOptionLabel={option => option.country_name}
                                            getOptionValue={option => option.id}
                                            value={lodash.find(all_countries, {
                                                id: sourceObject.source_detail.country
                                            })}
                                        />
                                    </Form.Field>
                                </Form.Group>

                                <Form.Group widths="equal">
                                    <Form.Field>
                                        <label>Data Refresh Frequency</label>
                                        <Select
                                            styles={{
                                                menu: provided => ({ ...provided, zIndex: 9999 })
                                            }}
                                            onChange={this.handleSourceDetailDropdowns}
                                            options={refreshOptions}
                                            placeholder="Select Refresh Frequency"
                                            isClearable={true}
                                            isSearchable={true}
                                            name="data_refresh_frequency"
                                            getOptionLabel={option => option.label}
                                            getOptionValue={option => option.value}
                                            value={lodash.find(refreshOptions, {
                                                value: sourceObject.source_detail.data_refresh_frequency
                                            })}
                                        />
                                    </Form.Field>
                                    <Form.Field>
                                        <label>Status</label>
                                        <Select
                                            styles={{
                                                menu: provided => ({ ...provided, zIndex: 9999 })
                                            }}
                                            onChange={this.handleSourceDetailDropdowns}
                                            options={statusOptions}
                                            placeholder="Status"
                                            isClearable={true}
                                            isSearchable={true}
                                            name="status"
                                            value={lodash.find(statusOptions, {
                                                value: sourceObject.source_detail.status
                                            })}
                                        />
                                    </Form.Field>
                                </Form.Group>

                                <div className="form-item-container">
                                    <p className="form-label">Consent Required</p>
                                    <Toggle
                                        defaultChecked={sourceObject.source_detail.consent_required}
                                        onChange={() => this.handleConsentToggle("consent_required")}
                                    />
                                </div>

                                {sourceObject.source_detail.consent_required
                                    ? (
                                        <div className="consent-details-container">
                                            <div className="form-item-container">
                                                    <p className="form-label">
                                                        Contractual Pass Through
                                                    </p>
                                                    <Toggle
                                                        defaultChecked={sourceObject.source_detail.contractual_passthrough}
                                                        onChange={(  ) =>
                                                            this.handleConsentToggle("contractual_passthrough")
                                                        }
                                                    />
                                                    <DocumentEditor
                                                        source={true}
                                                        resourceType={"passthrough_sample"}
                                                        value={sourceObject.source_detail.passthrough_sample}
                                                        initialValue={sourceObject.source_detail.passthrough_sample}
                                                        placeholderText={"Passthrough Sample Language."}
                                                    />
                                                </div>
                                            <div className="form-item-container">
                                                <p className="form-label">Consent Flag Required</p>
                                                <Toggle
                                                    defaultChecked={sourceObject.source_detail.consent_flag_required}
                                                    onChange={() =>
                                                        this.handleConsentToggle("consent_flag_required")
                                                    }
                                                />
                                                <DocumentEditor
                                                    source={true}
                                                    resourceType={"flag_required_sample"}
                                                    value={sourceObject.source_detail.flag_required_sample}
                                                    initialValue={sourceObject.source_detail.flag_required_sample}
                                                    placeholderText={"Flag Required Sample Language."}
                                                />
                                            </div>
                                        </div>
                                    )
                                    : null}

                                <div className="form-item-container">
                                    <p className="form-label">Source Description</p>
                                    <DocumentEditor
                                        source={true}
                                        resourceType={"source_type_description"}
                                        value={sourceObject.source_detail.source_type_description}
                                        initialValue={sourceObject.source_detail.source_type_description}
                                        placeholderText={"Source Type Description. This Will Be Included In The Source Reports."}
                                    />
                                    <br/>
                                </div>

                                <Form.Group widths="equal">
                                    <Form.Field
                                        control={Input}
                                        type="text"
                                        label="URL for Additional Information"
                                        placeholder="formatted as https://google.com"
                                        value={sourceObject.source_detail.resource_url}
                                        name="resource_url"
                                        onChange={this.handleSourceDetailChanges}
                                    />
                                </Form.Group>
                            </Card.Content>
                        </Card>

                        <Card fluid>
                            <Card.Content>
                                <h4 className="page-section-header">
                                    Notes:
                                </h4>

                                {sourceObject.notes.map((note, idx) => {
                                    const  placeholderText = note.type === "External"
                                        ? "Customer Specific Notes. This Will Be Included in the Source Reports."
                                        : "Internal Notes Regarding This Source"
                                    const labelText = note.type === "External"
                                        ? "Notes For The Customer."
                                        : "Internal GDC Notes."
                                        return(
                                            <div key={idx}>
                                                <h4>{labelText}</h4>
                                                <DocumentEditor
                                                    initialValue={note.note}
                                                    value={note.note}
                                                    notes={true}
                                                    source={true}
                                                    resourceType={note.type}
                                                    placeholderText={placeholderText}
                                                />
                                                <br/>
                                            </div>
                                        )
                                    })
                                }
                            </Card.Content>
                        </Card>

                        <Card fluid>
                            <Card.Content>
                                <h4 className="page-section-header">
                                    Verifiable Elements and Result Type:
                                </h4>

                                <Form.Field>
                                    <Table
                                        headers={[
                                            <Table.Header key="primary">Verifiable Element</Table.Header>,
                                            <Table.Header key="scores">Scores</Table.Header>,
                                            <Table.Header key="candidate-records">Candidate Records</Table.Header>,
                                            <Table.Header key="remove" />
                                        ]}
                                    >
                                        {sourceObject.verifiable_inputs.length > 0
                                            ? (
                                                sourceObject.verifiable_inputs.map((vi, idx) => {
                                                    return(
                                                        <tr key={idx}>
                                                            <td>{vi.label_name}</td>
                                                            <td>
                                                                <Radio
                                                                    value={vi.id}
                                                                    checked={vi.scores}
                                                                    change_obj={"scores"}
                                                                    onChange={this.handleResultTypeRadioButtonClick}
                                                                />
                                                            </td>
                                                            <td>
                                                                <Radio
                                                                    value={vi.id}
                                                                    checked={vi.candidate_records}
                                                                    change_obj={"candidate_records"}
                                                                    onChange={this.handleResultTypeRadioButtonClick}
                                                                />
                                                            </td>
                                                            <td style={{padding: "0"}}>
                                                                <Button
                                                                    size={"small"}
                                                                    color={"red"}
                                                                    value={vi.id}
                                                                    onClick={this.handleDeleteVerifiableInput}
                                                                    content="Delete Element"
                                                                />
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            )
                                            : null}

                                    </Table>

                                    {this.state.addNewVerifiableInputs
                                        ? (
                                            <div className="add-input-sidebar">
                                                <div className="form-item-container">
                                                    <Select
                                                        isMulti={true}
                                                        isClearable={true}
                                                        closeMenuOnSelect={true}
                                                        onChange={this.handleSelectVerifiableInputs}
                                                        options={inputFields}
                                                        placeholder="Select Verifiable Input"
                                                        getOptionLabel={option => option.label_name}
                                                        getOptionValue={option => option.label_id}
                                                        value={this.state.editVerifiableInputsArr}
                                                    />
                                                </div>

                                                <div className="inline-container">
                                                    <Button
                                                        onClick={(e) => this.handleAddNewVerifiableInputs(e)}
                                                        content="Done" />
                                                </div>
                                            </div>
                                        )
                                        : null}

                                    {this.state.addNewVerifiableInputs
                                        ? null
                                        : (
                                            <Button
                                                content={"+ Verifiable Input"}
                                                color={"blue"}
                                                onClick={(e) => this.handleAddNewVerifiableInputButtonClick(e)}
                                            />
                                        )}
                                </Form.Field>

                            </Card.Content>
                        </Card>

                        <div ref={this.messagesEndRef}/>
                    </Form>

                    {formWarningNotification || formErrorNotification
                        ? (
                            <div style={{paddingTop: "30px"}}>
                                <Message
                                    error={formErrorNotification}
                                    warning={formWarningNotification}
                                    header={formMessageHeader}
                                    list={formMessage}
                                    visible={formWarningNotification || formErrorNotification}
                                    onDismiss={this.handleDPSourceDismiss}
                                />
                            </div>
                        )
                        : null}
                </Container>
            </div>
        );
    }

}

const mapStateToProps = (state) => ({
    sourceDetail: state.veritas.sourceDetail.source,
    all_services: state.veritas.services.all_services,
    all_countries: state.veritas.countries.all_countries,

    sourceObject: state.veritas.addEdit.addEditDPSource.sourceObject,

    formMessage: state.marvel.message.formMessage,
    formWarningNotification: state.marvel.message.formWarningNotification,
    formErrorNotification: state.marvel.message.formErrorNotification,
    formMessageHeader: state.marvel.message.formMessageHeader,
});

const mapDispatchToProps = dispatch => ({
    toggleConsent: (name) => {dispatch(toggleConsentFieldValues(name))},

    getSourceDetail: (sourceID) => {dispatch(fetchSourceDetailFromID(sourceID))},

    updateSourceDetail: ({name, value}) => {dispatch(updateSourceDetail({name, value}))},
    updateSourceDetailDropdowns: ({name, change_obj}) => {dispatch(updateSourceDetailDropdowns({name, change_obj}))},
    updateNotesForSource: ({ name, value }) => {dispatch(updateNotesFieldForSource({ name, value }))},
    setAssociatedServiceValue: ({ service }) => {dispatch(setAssociatedServiceOptionValue({ service }))},
    setAssociatedCountryValue: ({ country }) => {dispatch(setAssociatedCountryOptionValue({ country }))},
    addVerifiableInputOption: (inputsArr) => {dispatch(addVerifiableInputs(inputsArr))},
    updateResultType: ({value, change_obj}) => {dispatch(updateResultType({value, change_obj}))},
    deleteVerifiableInput: ({value}) => {dispatch(deleteVerifiableInput({value}))},
});


export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(DataSourcesForm);
